module.exports = __webpack_public_path__ + "static/img/15.c9a58d2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/11/zh/15.png
// module id = N12i
// module chunks = 0